import { generatePdf } from "./core";
export async function downloadPDF(element, paramObj) {
    return generatePdf(element, "download", paramObj);
}
